export default [
  {
    name: 'Tame Impala',
    logo: require('@/assets/partners/tameimpala.svg'),
    href: '#'
  },
  {
    name: 'PT7',
    logo: require('@/assets/partners/pt7.svg'),
    href: '#'
  },
  {
    name: 'Popular VD',
    logo: require('@/assets/partners/popularvd.svg'),
    href: '#'
  },
  {
    name: 'Gus Gus',
    logo: require('@/assets/partners/gusgus.svg'),
    href: '#'
  },
  {
    name: 'Coachella',
    logo: require('@/assets/partners/coachella.svg'),
    href: '#'
  }
]
